module.exports = __webpack_public_path__ + "img/icn1.73ed85f7.svg";